import classNames from 'classnames';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { getFormValues, reduxForm } from 'redux-form/immutable';

// actions
import { currentManagerValidate } from '../../../actions/currentManagerActions';

// components
import ScheduleForm from '../_ScheduleForm';
import { Button } from '../../shared/_form';
import { Link } from 'react-router';
import { FormSection } from 'redux-form/immutable';

// constants
const FORM_NAME = 'managerNew';

class AppointmentsAvailabilities extends React.Component {
  static propTypes = {
    _handleBack: PropTypes.func,
    currentUser: PropTypes.instanceOf(Immutable.Map),
    form:        PropTypes.string,
    formValues:  PropTypes.instanceOf(Immutable.Map)
  };

  render() {
    const { currentUser, formValues, _handleGoBack } = this.props;

    const loading = currentUser.get('loading');

    return (
      <div className='manager-new__step2'>
        <p className='manager-new__step2__description'>
          Appointments are available:
        </p>
        <form className='manager-new__step2__form' onSubmit={ this._handleSubmit }>
          <FormSection name='office.schedule'>
            <ScheduleForm form={ FORM_NAME }
              formValues={ formValues } />
          </FormSection>
          <div className='form__submit'>
            <Link className={ classNames('form__button form__button--purple manager-new__form__button', { 'form__button--disabled': loading }) }
              to={ _handleGoBack }>
              Back
            </Link>
            <Button className='form__button form__button--green manager-new__form__button'
              loading={ loading }>
              Next
            </Button>
          </div>
        </form>
      </div>
    );
  }

  // private

  _handleSubmit   = this._handleSubmit.bind(this);

  _handleSubmit(e) {
    e.preventDefault();

    const form = this.props.formValues || Immutable.Map();
    const { dispatch } = this.props;

    if (ScheduleForm.validate(this.props)) {
      dispatch(currentManagerValidate(form.toJS()));
    }
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.get('currentUser'),
    formValues:  getFormValues(FORM_NAME)(state)
  };
};

export default (
  connect(mapStateToProps)(
    reduxForm(
      {
        destroyOnUnmount: false,
        form: FORM_NAME
      }
    )(AppointmentsAvailabilities)
  )
);



// WEBPACK FOOTER //
// ./app/components/managers/signUp/_AppointmentsAvailabilities.jsx